export { CircleDonut as default } from './CircleDonut';
